import PageNameBanner from "../../components/page-name-banner/PageNameBanner";
import Form from "./components/form/Form";
import './subscription-form.css'



export default function SubscriptionForm (){
    // const formURL = 'https://na4.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=88f8c4c1-e95f-4d84-a28c-fd2e032c53a3&env=na4&acct=c4911c48-8f4b-4910-848b-d4ec7431d966&v=2'


    return(

        <>
            <PageNameBanner pageName="Subscribe to us Form"/>
            {/* <iframe src={formURL} className="docuSignForm"/> */}
      <div className="subscription">
        <div className="subscription-form-container">
          <div className="subscription-text">
            <h2 className="">Submit Request</h2>
          </div>
          <Form/>
        </div>
      </div>
    </>
    )
}
